var appObject={
    //应用信息
}
/**
 * 获取应用信息
 */
function getAppInfo(){
    return this.appObject;
}
/**
 * 设置应用信息
 * @param {*} object 
 */
function setAppInfo(object){
    this.appObject = object;
}

export default {
    getAppInfo,
    setAppInfo,
    appObject:appObject
}